import bwipjs from 'bwip-js';
import $ from 'jquery';

import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  cardNumberForm,
  closeBottomSheet,
  deserialize,
  getIframe,
  getIframeById,
  getMethodModalLayer,
  getMethodRegiModalLayer,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  setModal,
  showBottomSheet,
  stringToHTML,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter, isEmpty } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const OnsitePay = {
  time: 120,
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">현장 결제</div>
      <div class="m_b_60">
          <div class="c_box m_b_20">
              <div class="c_box">
                <a id="onsite_pay_qrcode" href="javascript:void(0)" data-toggle="modal" data-target="#qrcode_full" class="c_label3">
                  <img src="${SDK_DOMAIN}/images/qr-code_1.svg" /> QR 보기
                </a>
              </div>
              <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
          </div>
          <div class="m_b_40 text_center">
              <div class="m_b_10 c_bar_qr">
                <a id="onsite_pay_barcode" href="javascript:void(0)" data-toggle="modal" data-target="#barcode_full">
                  <img id="base_barcode_image" />
                </a>
              </div>
              <div id="base_barcode" class="c_label4_5"></div>
          </div>
          <div class="c_onsite_card" id="mothod_back">
              <div id="card_top_left" class="c_label7">충전머니</div>
              <div class="c_box">
                  <div id="card_bottom_left" class="c_label7_1">현재잔액</div>
                  <div id="card_bottom_right" class="c_label7">0 원</div>
              </div>
              <img class="c_onsite_card_opacity" src="${SDK_DOMAIN}/images/card_opacity.svg"/>
          </div>
      </div>
      <div class="form-group m_b_120">
          <div class="c_bod1 c_box skin1_bod" id="payment_method">
              <input type="hidden" id="method_info" name="method_info" />
              <div id="selected_method" class="c_label4_3">충전머니</div>
              <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
          </div>
      </div>
      <div class="c_box c_btm2">
          <div id="pay_method"><a class="item">< 결제 수단 관리</a></div>
          <div id="payment_details"><a class="item">결제 내역 보기 ></a></div>
      </div>
      <div class="modal fade c_modal" id="qrcode_full">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="c_box m_b_30">
                          <div class="c_box"><a href="javascript:void(0)" id="qrcode_toggle" class="c_label3"><img src="${SDK_DOMAIN}/images/barcode_1.svg" /> 바코드 보기</a></div>
                          <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                      </div>
                      <div class="text_center">
                          <div class="m_b_30 c_bar_qr">
                            <img id="modal_qrcode_image" />
                          </div>
                          <div id="modal_qrcode" class="c_label4_5"></div>
                      </div>
                  </div>
                  <div class="modal-footer"></div>
              </div>
          </div>
      </div>
      <div class="modal fade c_modal horizontal_1" id="barcode_full">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="c_box m_b_20">
                          <div class="c_box"><a href="javascript:void(0)"  id="barcode_toggle" class="c_label3"><img src="${SDK_DOMAIN}/images/qr-code_1.svg" /> QR 보기</a></div>
                          <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                      </div>
                      <div class="text_center">
                          <div class="m_b_20 c_bar_qr">
                            <img id="modal_barcode_image" />
                          </div>
                          <div id="modal_barcode" class="c_label4_5"></div>
                      </div>
                  </div>
                  <div class="modal-footer"></div>
              </div>
          </div>
      </div>
    `;
  },
  afterRender: async () => {
    setAlertModal();

    let timer; // setInterval 변수

    try {
      const methodModalLayer = await getMethodModalLayer();
      stringToHTML(methodModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
    } catch (e) {
      showAlertModal('오류', e.resultMessage);
    }
    const methodRegiModalLayer = await getMethodRegiModalLayer();

    const qrcodeModalLayer = `
      <div class="modal fade c_modal" id="qrcode_full">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="c_box m_b_30">
                          <div class="c_box"><a href="javascript:void(0)"><img src="${SDK_DOMAIN}/images/payro_1.png" /></a></div>
                          <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                      </div>
                      <div class="text_center">
                          <div class="m_b_30 c_bar_qr"><img src="${SDK_DOMAIN}/images/qr-code.png" /></div>
                          <div class="c_label4_5"></div>
                      </div>
                  </div>
                  <div class="modal-footer"></div>
              </div>
          </div>
      </div>
      `;

    const barcodeModalLayer = `
      <div class="modal fade c_modal" id="barcode_full">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="c_box m_b_20">
                          <div class="c_box"><a href="javascript:void(0)"><img src="${SDK_DOMAIN}/images/payro_1.png" /></a></div>
                          <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                      </div>
                      <div class="text_center">
                          <div class="m_b_20 c_bar_qr"><img src="${SDK_DOMAIN}/images/barcode_2.png" /></div>
                          <div class="c_label4_5"></div>
                      </div>
                  </div>
                  <div class="modal-footer"></div>
              </div>
          </div>
      </div>
    `;

    // 결제수단 변경
    const handleMethodChanged = (methodInfoStr) => {
      if (isEmpty(methodInfoStr)) return;

      localStorage.setItem('CONPAY_SELECTED_METHOD_INFO', methodInfoStr);
      const methodInfo = deserialize(methodInfoStr);

      let methodNm = '';
      let cardTopLeftText = '충전머니';
      let cardBottomLeftText = '현재잔액';
      let cardBottomRightText = `${amtFormatter(methodInfo.moneyBalance)} 원`;
      let backGroundColor = '';

      switch (methodInfo.trDiv) {
        case '1001':
          localStorage.setItem('CONPAY_SELECTED_METHOD', methodInfo.cardEntyno);
          methodNm = `${methodInfo.cardCoName} ${cardNumberForm(
            methodInfo.cardBin
          )}`;
          cardTopLeftText = '카드';
          cardBottomLeftText = `${cardNumberForm(methodInfo.cardBin)}`;
          cardBottomRightText = '';
          backGroundColor = methodInfo.ref1 || 'var(--activeColor)';
          break;
        case '2001':
          localStorage.setItem('CONPAY_SELECTED_METHOD', methodInfo.accEntyno);
          methodNm = `${methodInfo.bnkName} ${methodInfo.accno}`;
          cardTopLeftText = '계좌';
          cardBottomLeftText = `${methodInfo.bnkName} ${methodInfo.accno}`;
          cardBottomRightText = '';
          backGroundColor = methodInfo.ref2 || '#000555';
          break;
        default:
          localStorage.setItem('CONPAY_SELECTED_METHOD', 'money');
          methodNm = `충전머니 ${amtFormatter(methodInfo.moneyBalance)} 원`;
          break;
      }

      //컬러 값 변경 시그니처 색으로 변경
      const cardBackground = getIframe().getElementById('mothod_back');
      cardBackground.style.backgroundColor = backGroundColor;

      setIframeInnerHtml('card_top_left', cardTopLeftText);
      setIframeInnerHtml('card_bottom_left', cardBottomLeftText);
      setIframeInnerHtml('card_bottom_right', cardBottomRightText);

      getIframe().getElementById('method_info').value = methodInfoStr;
      setIframeInnerHtml('selected_method', methodNm);

      resetCodes();
      setBarCode();
      clearInterval(timer);
      setTimer('timer', OnsitePay.time);

      closeBottomSheet('payment_method');
    };

    // set 바코드
    const setBarCode = async () => {
      const methodInfo = deserialize(
        localStorage.getItem('CONPAY_SELECTED_METHOD_INFO')
      );
      const trDiv = methodInfo.trDiv;

      let rsvdData;
      switch (trDiv) {
        case '1001':
          rsvdData = {
            trDiv,
            cardEntyno: methodInfo.cardEntyno,
          };
          break;
        case '2001':
          rsvdData = {
            trDiv,
            accEntyno: methodInfo.accEntyno,
          };
          break;
        default:
          rsvdData = {
            trDiv,
          };
          break;
      }

      try {
        const resultData = await postApv('common/rsvd/off', rsvdData);

        const barCodeData = resultData.barCodeData;
        setIframeInnerHtml('base_barcode', barCodeData);
        setIframeInnerHtml('modal_barcode', barCodeData);
        setIframeInnerHtml('modal_qrcode', barCodeData);

        const canvas = document.createElement('canvas');

        bwipjs.toCanvas(canvas, {
          bcid: 'code128',
          text: barCodeData,
          height: 12,
        });
        getIframe().getElementById('base_barcode_image').src =
          canvas.toDataURL('image/png');
        getIframe().getElementById('modal_barcode_image').src =
          canvas.toDataURL('image/png');

        bwipjs.toCanvas(canvas, {
          bcid: 'qrcode',
          text: barCodeData,
          scale: 4,
        });
        getIframe().getElementById('modal_qrcode_image').src =
          canvas.toDataURL('image/png');
      } catch (e) {
        showAlertModal('오류', e.resultMessage || e);
        console.error(e.resultMessage || e);
      }
    };

    // QR, 바코드, text 타임아웃
    const timeOutCodes = () => {
      const timeoutQrCodeImg = `${SDK_DOMAIN}/images/qrcord01_opacity10.svg`;
      const timoutBarCodeImg = `${SDK_DOMAIN}/images/barcode01_opacity10.svg`;

      getIframe().getElementById('modal_qrcode_image').src = timeoutQrCodeImg;
      getIframe().getElementById('base_barcode_image').src = timoutBarCodeImg;
      getIframe().getElementById('base_barcode_image').style.cursor = 'initial';
      getIframe().getElementById('modal_barcode_image').src = timoutBarCodeImg;

      [...getIframe().getElementsByClassName('c_label4_5')].map((el) =>
        el.classList.add('time_out_text')
      );
    };

    // QR, 바코드, text 타임아웃 해제
    const resetCodes = () => {
      getIframe().getElementById('modal_qrcode_image').src = '';
      getIframe().getElementById('base_barcode_image').src = '';
      getIframe().getElementById('modal_barcode_image').src = '';
      getIframe().getElementById('base_barcode_image').style.cursor = 'pointer';

      [...getIframe().getElementsByClassName('c_label4_5')].map((el) =>
        el.classList.remove('time_out_text')
      );
    };

    // set 타이머
    const setTimer = (classNm, time) => {
      timer = setInterval(() => {
        const min = parseInt(time / 60);
        const sec = String(time % 60);

        if (getIframeById() == null) {
          clearInterval(timer);
          return;
        }

        [...getIframe().getElementsByClassName(classNm)].map(
          (el) =>
            (el.textContent = `${min == 0 ? '00' : '0' + min}:${
              sec.length == 1 ? '0' + sec : sec
            }`)
        );
        time--;

        // timeout
        if (time < 0) {
          timeOutCodes();
          clearInterval(timer);
          [...getIframe().getElementsByClassName(classNm)].map(
            (el) => (el.textContent = '00:00')
          );
          return true;
        }
      }, 1000);
    };

    stringToHTML(methodRegiModalLayer).children[0].appendAfter(
      getIframe().getElementById('layer-wrapper')
    );

    stringToHTML(qrcodeModalLayer).children[0].appendAfter(
      getIframe().getElementById('layer-wrapper')
    );
    stringToHTML(barcodeModalLayer).children[0].appendAfter(
      getIframe().getElementById('layer-wrapper')
    );
    setModal('onsite_pay_qrcode', 'qrcode_full');
    setModal('onsite_pay_barcode', 'barcode_full');

    getIframe()
      .querySelectorAll('#payment_method_list > div')
      .forEach((element) => {
        element.getAttribute('id') == 'pay_method_regi'
          ? element.addEventListener('click', () =>
              closeBottomSheet('payment_method')
            )
          : element.addEventListener('click', () => {
              getIframe()
                .querySelectorAll('#payment_method_list > div')
                .forEach((item) => {
                  item.className =
                    element.id === item.id
                      ? 'item c_label6'
                      : 'item c_label6_1';
                });

              handleMethodChanged(element.getAttribute('value'));
            });
      });

    getIframe()
      .querySelectorAll('#pay_method_regi_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          closeBottomSheet('pay_method_regi');
          clearInterval(timer);
          pushRouter(null, null, element.getAttribute('value'), () => {
            setDisableBackControl();
          });
        });
      });

    getIframe()
      .querySelectorAll('.reload_img')
      .forEach((element) => {
        element.addEventListener('click', () => {
          resetCodes();
          setBarCode();
          clearInterval(timer);
          setTimer('timer', OnsitePay.time);
        });
      });
    setAddEventListener('pay_method', () => {
      clearInterval(timer);
      pushRouter(null, null, routes.payMethod.hashPath);
    });
    setAddEventListener('payment_details', () => {
      clearInterval(timer);
      pushRouter(null, null, routes.paymentDetails.hashPath);
    });
    setAddEventListener('connect_pay_back_button', () => {
      clearInterval(timer);
      history.back();
    });
    window.onhashchange = (e) => {
      if (e.oldURL.includes(routes.onsitePay.hashPath)) clearInterval(timer);
    };
    // 바코드 -> QR코드
    setModal('qrcode_toggle', 'barcode_full');
    $(`iframe`)
      .contents()
      .find('#qrcode_full')
      .on('show.bs.modal', () => {
        $(`iframe`).contents().find('#barcode_full').modal('hide');
        $(`iframe`).contents().find('.modal-backdrop').remove();
      });

    // QR코드 -> 바코드
    setModal('barcode_toggle', 'qrcode_full');
    $(`iframe`)
      .contents()
      .find('#barcode_full')
      .on('show.bs.modal', () => {
        $(`iframe`).contents().find('#qrcode_full').modal('hide');
        $(`iframe`).contents().find('.modal-backdrop').remove();
      });

    setBottomSheet('payment_method');
    setBottomSheet('pay_method_regi');

    // 등록된 결제수단(카드, 계좌) 하나도 없으면 '결제수단 추가 BottomSheet' 보여줌
    const methodListResult = await getApv('common/methodList');
    if (
      methodListResult.cardList?.length == 0 &&
      methodListResult.accountList?.length == 0
    ) {
      showBottomSheet('pay_method_regi');
    } else {
      // 결제수단 초기세팅
      handleMethodChanged(localStorage.getItem('CONPAY_SELECTED_METHOD_INFO'));
    }
  },
};
export default OnsitePay;
